<template>
    <modal class="new-modal-default log-attachments" transition="nice-modal-fade" :name="modal_name" :delay="100"
        :width="200" height="auto" :adaptive="true" :scrollable="true">
        <div class="v-modal-content" style="background-color: #ffffff !important;">
            <div class="v-modal-header">
                <div></div>
                <div>
                    <span class="v-modal-dialog-title v-modal-title text-white">Log Attachments</span>
                </div>
                <div>
                    <span class="icon icon-close text-white pointer close-left" @click="hideModal"></span>
                </div>
            </div>
            <div class="v-modal-body">
                <div class="v-modal-layout" style="max-height: 300px">
                    <div class="row">
                        <div class="col-lg-12 col-md-12 col-sm-12" v-for="(att, att_index) in log_attachments" :key="att_index">
                            <div class="d-flex justify-content-between align-items-center">
                                <div class="d-flex align-items-center">
                                    <span  class="_images" @click="previewImage(att)">
                                        <img class="att-img pointer" v-if="att.url.endsWith('.pdf')"
                                            src="https://cdn.digicollect.com/cdn/scmnew/images/scm/pdf-attachment.svg" />
                                        <img class="att-img pointer" v-else-if="att.url.endsWith('.svg')"
                                            src="https://cdn.digicollect.com/cdn/scmnew/images/scm/svg-icon.svg" />
                                        <img class="att-img pointer" v-else-if="att.url.endsWith('.xls') || att.name.endsWith('.xlsx')"
                                            src="https://cdn.digicollect.com/cdn/scmnew/images/scm/xls.svg" />
                                        <img class="att-img pointer" v-else-if="att.url.endsWith('.doc') || att.name.endsWith('.docx')"
                                            src="https://cdn.digicollect.com/cdn/scmnew/images/scm/docx.svg" />
                                        <img class="att-img pointer" v-else-if="att.url.endsWith('.avi') || att.name.endsWith('.flv') || att.name.endsWith('.mpg') || att.name.endsWith('.mpeg') || att.name.endsWith('.mp4') || att.name.endsWith('.wav') || att.name.endsWith('.wmv') || att.name.endsWith('.MOV') || att.name.endsWith('.mov')"
                                            src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/default_video.svg" />
                                        <img class="att-img pointer" v-else :src="att.url" alt="">
                                    </span>
                                    <div class="fw-500 d-inline-block overflowing-text attachment_name" :title="att.name">{{att.name}}</div>
                                </div>
                                <div>
                                    <a class="pointer" :href="att.url" download style="text-decoration: none;">
                                        <i class="icon icon-download"></i>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </modal>
</template>

<script>
var mime = require('mime-types')
import Preview from '../Preview.vue'
export default{
    props: ['modal_name', 'log_attachments'],
    data(){
        return{
            preview_file: '',
            preview_visible: false,
        }
    },
    components: {
        Preview
    },
    methods: {
        hideModal(){
            this.$emit('hideLogAttachments')
        },
        previewImage(file) {
            this.$emit('previewImage', file)
        },
    }
}
</script>

<style scoped>
._images{
	margin: 5px;
	padding: 5px;
	border-radius: 2.5px;
	box-shadow: 0 1.5px 3px 0 rgba(0, 0, 0, 0.2);
	background-color: #f6f8ff;
	width: 177px !important;
    height: 100px !important;
	display: flex;
	flex-direction: column;
}
._images>img{
    height: 90px;
}
</style>